import axios from "axios";
import React, { useEffect } from "react";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { apiKey } from "../../../config/config";
import MessageCard from "../../../components/AdminCards/MessageCard";
import handleCSRF from "../../../config/CSRF";
import Select from "react-select";
import { languageHelper } from "../../../config/helperFunctions";

function AddCouponForm() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const { id } = useParams();
  const [error, setError] = useState();
  const [pageLoading, setPageLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    code: "",
    minimum_purchase_price: "",
    dis_type: "",
    expired_date: "",
    status: 1,
    discount_amount: "",
    user_id: user.user.id,
    outlet_id: user.user.outlet_id,
  });

  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSelectChange = (e) => {
    setFormData({
      ...formData,
      [e.name]: e.value,
    });
  };

  const discountTypes = [
    {
      label: languageHelper("Amount"),
      value: "amount",
      name: "dis_type",
    },
    {
      label: languageHelper("Percentage"),
      value: "percentage",
      name: "dis_type",
    },
  ];

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    if (!id) {
      axios
        .post(`${apiKey}/api/rms/admin/coupons`, formData, {
          headers: {
            withCredentials: true,
            Authorization: `Bearer ${user.token}`,
            // "X-XSRF-TOKEN": decodeURIComponent(csrfToken),
          },
        })
        .then((res) => {
          toast.success("Success", {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          navigate(-1);
        })
        .catch((err) => {
          Object.keys(err.response.data.data).forEach((item) => {
            err.response.data.data[item].forEach((i) => {
              toast.error(i || "Validation Error");
            });
          });
        })
        .finally(() => setLoading(false));
    } else {
      axios
        .put(`${apiKey}/api/rms/admin/coupons/${id}`, formData, {
          headers: {
            withCredentials: true,
            Authorization: `Bearer ${user.token}`,
          },
        })
        .then((res) => {
          toast.success("Success", {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          navigate(-1);
        })
        .catch((err) => {
          Object.keys(err.response.data.data).forEach((item) => {
            err.response.data.data[item].forEach((i) => {
              toast.error(i || "Validation Error");
            });
          });
        })
        .finally(() => setLoading(false));
    }
  };

  useEffect(() => {
    if (id) {
      setPageLoading(true);
      const fetchCoupon = () => {
        axios
          .get(`${apiKey}/api/rms/admin/coupons/${id}`, {
            headers: {
              withCredentials: true,
              Authorization: `Bearer ${user.token}`,
            },
          })
          .then((res) => {
            setFormData(res.data);
          })
          .catch((err) => {
            setError(err.response.data.message);
          })
          .finally(() => {
            setPageLoading(false);
          });
      };
      handleCSRF(fetchCoupon);
    }
  }, [id, user.token]);

  if (error) {
    return <MessageCard error={error} />;
  }

  if (pageLoading) {
    return (
      <div className="absolute top-0 left-0 w-full h-full grid place-items-center">
        <img src="/assets/gif/dash2.gif" alt="" />
      </div>
    );
  }

  return (
    <main>
      <div className="relative my-16 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-4 border-0">
        <div className="flex justify-between items-center mb-4">
          <div className="flex justify-between items-center mb-4">
            <h1 className="text-d-bg-text text-2xl">
              {languageHelper("Coupon") || "Coupon"}
            </h1>
          </div>
        </div>
        <div className="w-full">
          <form className="w-full" onSubmit={handleSubmit}>
            <div className="flex flex-col md:flex-row gap-x-8 gap-y-2 w-full">
              <label htmlFor="" className="w-full md:w-1/2">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  {languageHelper("Name") || "Name"}
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    name="name"
                    onChange={handleChange}
                    value={formData.name}
                    placeholder={languageHelper("Name") || "Name"}
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    required
                  />
                </div>
              </label>
              <label htmlFor="" className="w-full md:w-1/2">
                <span className="text-d-bg-text text-sm mb-2  relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  {languageHelper("Code") || "Code"}
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder={languageHelper("Code") || "Code"}
                    name="code"
                    value={formData.code}
                    onChange={handleChange}
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                  />
                </div>
              </label>
            </div>

            <div className="flex flex-col md:flex-row gap-x-8 gap-y-2 w-full pt-3">
              <label htmlFor="" className="w-full md:w-1/2">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  {languageHelper("Minimum Purchase Price") ||
                    "Minimum Purchase Price"}
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    name="minimum_purchase_price"
                    onChange={handleChange}
                    value={formData.minimum_purchase_price}
                    placeholder={
                      languageHelper("Minimum Purchase Price") ||
                      "Minimum Purchase Price"
                    }
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    required
                  />
                </div>
              </label>
              <label htmlFor="" className="w-full md:w-1/2">
                <span className="text-d-bg-text text-sm mb-2  relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  {languageHelper("Expired date") || "Expired date"}
                </span>
                <div className="mb-2 pt-0">
                  <div>
                    <input
                      type="date"
                      placeholder=""
                      name="expired_date"
                      value={formData.expired_date}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </label>
            </div>

            <div className="flex flex-col md:flex-row gap-x-8 gap-y-2 w-full pt-3">
              <label htmlFor="" className="w-full md:w-1/2">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  {languageHelper("Discount Type") || "Discount Type"}
                </span>
                <div className="mb-2 pt-0">
                  <Select
                    type="text"
                    className=" placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    required
                    placeholder={languageHelper("Select") || "Select"}
                    options={discountTypes}
                    defaultValue={{
                      value: formData.dis_type,
                      label:
                        formData.dis_type === "percentage"
                          ? languageHelper("Percentage") || "Percentage"
                          : formData.dis_type === "amount"
                            ? languageHelper("Amount") || "Amount"
                            : "",
                    }}
                    onChange={handleSelectChange}
                  />
                </div>
              </label>
              <label htmlFor="" className="w-full md:w-1/2">
                <span className="text-d-bg-text text-sm mb-2  relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  {languageHelper("Amount") || "Amount"}
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    name="discount_amount"
                    onChange={handleChange}
                    value={formData.discount_amount}
                    placeholder={languageHelper("Amount") || "Amount"}
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                  />
                </div>
              </label>
            </div>

            <div className="form-check text-d-bg-text pb-4">
              <div className="pt-3 pb-2">
                {" "}
                <h2>{languageHelper("Status") || "Status"}</h2>
              </div>
              <input
                type="radio"
                name="status"
                id="exampleRadios1"
                value={1}
                checked={parseInt(formData.status) === 1}
                onChange={handleChange}
              />
              <label
                className="form-check-label pe-5 ps-3 "
                for="exampleRadios1"
              >
                {languageHelper("Active") || "Active"}
              </label>
              <input
                className="ps-5"
                type="radio"
                name="status"
                id="exampleRadios2"
                value={0}
                checked={parseInt(formData.status) === 0}
                onChange={handleChange}
              />
              <label className="form-check-label ps-3" for="exampleRadios2">
                {languageHelper("Inactive") || "Inactive"}
              </label>
            </div>

            <span className="w-full bg-d-bg h-1 my-2 inline-block"></span>
            <div className="flex gap-2">
              <button
                className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit relative"
                type="submit"
              >
                {loading && (
                  <span className="absolute top-0 left-0 w-full h-full py-1 px-3 bg-black bg-opacity-50">
                    <img
                      className="w-4 mx-auto"
                      src="/assets/gif/button_loader.gif"
                      alt=""
                    />
                  </span>
                )}
                {languageHelper("Submit") || "Submit"}
              </button>
              <button
                className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                type="button"
                onClick={() => navigate(-1)}
              >
                {languageHelper("Back") || "Back"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </main>
  );
}

export default AddCouponForm;
